import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class UrlService {
    public prefix: string;
    public publicPrefix: string; // for org img in feb-2024

    public setPrefix(prefix: string){
        this.prefix = prefix;
    }

    public setPublicPrefix(prefix: string){
        this.publicPrefix = prefix;
    }

    public build(url: string): string{
        return environment.twonaBaseUrl + this.prefix + url;
    }

    public buildPublic(url: string): string{
        return environment.twonaBaseUrl + this.publicPrefix + url;
    }

    public buildLogin(url: string): string{
        return environment.loginApiBaseUri + url;
    }

    /**
     * uses the environment variable filesApiUri to build the full url for files api
     * @param url the url to build
     * @returns the full url for files api
     */
    public buildFiles(url: string): string {
        return environment.storageApiBaseUri + url;
    }

    /**
     * uses the environment variable accountsApiBaseUri to build the full url for accounts api
     * @param url the url to build
     * @returns the full url for accounts api
     */
    public buildAccounts(url: string): string {
        return environment.accountsApiBaseUri + url;
    }

}
